import * as ambassadorWixMembersV1MemberRoleDefinition from './members-v1-member-role-definition-member-role-definition.http.js';
import * as ambassadorWixMembersV1MemberRoleDefinitionTypes from './members-v1-member-role-definition-member-role-definition.types.js';
import * as ambassadorWixMembersV1MemberRoleDefinitionUniversalTypes from './members-v1-member-role-definition-member-role-definition.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createMemberRoleDefinition(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1MemberRoleDefinitionUniversalTypes.CreateMemberRoleDefinitionRequest,
  ambassadorWixMembersV1MemberRoleDefinitionTypes.CreateMemberRoleDefinitionRequest,
  ambassadorWixMembersV1MemberRoleDefinitionUniversalTypes.CreateMemberRoleDefinitionResponse,
  ambassadorWixMembersV1MemberRoleDefinitionTypes.CreateMemberRoleDefinitionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1MemberRoleDefinition.createMemberRoleDefinition(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/roles/definitions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listMemberRoleDefinitions(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMembersV1MemberRoleDefinitionUniversalTypes.ListMemberRoleDefinitionsRequest,
  ambassadorWixMembersV1MemberRoleDefinitionTypes.ListMemberRoleDefinitionsRequest,
  ambassadorWixMembersV1MemberRoleDefinitionUniversalTypes.ListMemberRoleDefinitionsResponse,
  ambassadorWixMembersV1MemberRoleDefinitionTypes.ListMemberRoleDefinitionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1MemberRoleDefinition.listMemberRoleDefinitions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/roles/definitions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getMemberRoleDefinition(): __PublicMethodMetaInfo<
  'GET',
  { roleKey: string },
  ambassadorWixMembersV1MemberRoleDefinitionUniversalTypes.GetMemberRoleDefinitionRequest,
  ambassadorWixMembersV1MemberRoleDefinitionTypes.GetMemberRoleDefinitionRequest,
  ambassadorWixMembersV1MemberRoleDefinitionUniversalTypes.GetMemberRoleDefinitionResponse,
  ambassadorWixMembersV1MemberRoleDefinitionTypes.GetMemberRoleDefinitionResponse
> {
  const payload = { roleKey: ':roleKey' } as any;

  const getRequestOptions =
    ambassadorWixMembersV1MemberRoleDefinition.getMemberRoleDefinition(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/roles/definitions/{roleKey}',
    pathParams: { roleKey: 'roleKey' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateMemberRoleDefinition(): __PublicMethodMetaInfo<
  'PATCH',
  { key: string },
  ambassadorWixMembersV1MemberRoleDefinitionUniversalTypes.UpdateMemberRoleDefinitionRequest,
  ambassadorWixMembersV1MemberRoleDefinitionTypes.UpdateMemberRoleDefinitionRequest,
  ambassadorWixMembersV1MemberRoleDefinitionUniversalTypes.UpdateMemberRoleDefinitionResponse,
  ambassadorWixMembersV1MemberRoleDefinitionTypes.UpdateMemberRoleDefinitionResponse
> {
  const payload = { key: ':key' } as any;

  const getRequestOptions =
    ambassadorWixMembersV1MemberRoleDefinition.updateMemberRoleDefinition(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/roles/definitions/{key}',
    pathParams: { key: 'key' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteMemberRoleDefinition(): __PublicMethodMetaInfo<
  'DELETE',
  { roleKey: string },
  ambassadorWixMembersV1MemberRoleDefinitionUniversalTypes.DeleteMemberRoleDefinitionRequest,
  ambassadorWixMembersV1MemberRoleDefinitionTypes.DeleteMemberRoleDefinitionRequest,
  ambassadorWixMembersV1MemberRoleDefinitionUniversalTypes.DeleteMemberRoleDefinitionResponse,
  ambassadorWixMembersV1MemberRoleDefinitionTypes.DeleteMemberRoleDefinitionResponse
> {
  const payload = { roleKey: ':roleKey' } as any;

  const getRequestOptions =
    ambassadorWixMembersV1MemberRoleDefinition.deleteMemberRoleDefinition(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/roles/definitions/{roleKey}',
    pathParams: { roleKey: 'roleKey' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  MemberRoleDefinition as MemberRoleDefinitionOriginal,
  SyncMetaSiteRolesRequest as SyncMetaSiteRolesRequestOriginal,
  SyncMetaSiteRolesResponse as SyncMetaSiteRolesResponseOriginal,
  CreateMemberRoleDefinitionRequest as CreateMemberRoleDefinitionRequestOriginal,
  CreateMemberRoleDefinitionResponse as CreateMemberRoleDefinitionResponseOriginal,
  ListMemberRoleDefinitionsRequest as ListMemberRoleDefinitionsRequestOriginal,
  ListMemberRoleDefinitionsResponse as ListMemberRoleDefinitionsResponseOriginal,
  GetMemberRoleDefinitionRequest as GetMemberRoleDefinitionRequestOriginal,
  GetMemberRoleDefinitionResponse as GetMemberRoleDefinitionResponseOriginal,
  UpdateMemberRoleDefinitionRequest as UpdateMemberRoleDefinitionRequestOriginal,
  UpdateMemberRoleDefinitionResponse as UpdateMemberRoleDefinitionResponseOriginal,
  DeleteMemberRoleDefinitionRequest as DeleteMemberRoleDefinitionRequestOriginal,
  DeleteMemberRoleDefinitionResponse as DeleteMemberRoleDefinitionResponseOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  Empty as EmptyOriginal,
  UpdateMemberRoleDefinitionApplicationErrors as UpdateMemberRoleDefinitionApplicationErrorsOriginal,
  DeleteMemberRoleDefinitionApplicationErrors as DeleteMemberRoleDefinitionApplicationErrorsOriginal,
} from './members-v1-member-role-definition-member-role-definition.types.js';
